import React from "react";
import { motion } from "framer-motion";
import { fmtPKR } from "@/lib/format";

const Box = ({ b, clickable, onClick, i }) => {
  const shown = b.prize !== null && b.prize !== undefined;
  return (
    <motion.button type="button" disabled={!clickable} onClick={onClick}
      initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.02 }}
      whileHover={clickable ? { y: -4, scale: 1.04 } : undefined} whileTap={clickable ? { scale: 0.96 } : undefined}
      className={`relative aspect-[4/3] rounded-xl border text-center flex flex-col items-center justify-center transition-colors
        ${b.own ? "border-[#E8C766] bg-gradient-to-b from-[#C9A227] to-[#866812] shadow-[0_0_24px_rgba(201,162,39,0.55)]" :
          b.opened ? "border-white/10 bg-[rgba(255,255,255,0.04)]" :
          "border-[rgba(232,199,102,0.45)] bg-gradient-to-b from-[#1F4690] to-[#0B2455]"}
        ${clickable ? "cursor-pointer hover:border-[#E8C766]" : "cursor-default"}`}
      data-testid={`dnd-box-${b.box}`}>
      {shown && b.opened ? (
        <motion.span initial={{ rotateX: 90 }} animate={{ rotateX: 0 }} className="text-[11px] sm:text-sm font-bold text-[#E8C766] keep-ltr">{fmtPKR(b.prize)}</motion.span>
      ) : (
        <>
          <span className="font-head text-lg sm:text-2xl font-extrabold text-pure">{b.box}</span>
          {b.own && <span className="text-[9px] uppercase tracking-widest text-pure/90 font-bold">Your box</span>}
          {shown && b.own && <span className="text-[10px] font-bold text-pure keep-ltr">{fmtPKR(b.prize)}</span>}
        </>
      )}
    </motion.button>
  );
};

export const DndBoard = ({ game, onBox }) => {
  const phase = game?.status;
  return (
    <div className="grid grid-cols-4 sm:grid-cols-5 gap-2 sm:gap-3" data-testid="dnd-board">
      {game.boxes.map((b, i) => {
        const clickable = (phase === "pick_own") || (phase === "opening" && !b.own && !b.opened);
        return <Box key={b.box} b={b} i={i} clickable={clickable} onClick={() => onBox(b.box)} />;
      })}
    </div>
  );
};

export const PrizeBoard = ({ prizes, remaining }) => {
  const left = remaining ? [...remaining] : null;
  return (
    <div className="grid grid-cols-2 gap-1.5 text-xs" data-testid="dnd-prize-board">
      {prizes.map((p, i) => {
        let live = true;
        if (left) {
          const k = left.indexOf(p);
          if (k >= 0) left.splice(k, 1); else live = false;
        }
        return (
          <div key={i} className={`rounded-lg px-2 py-1.5 text-center font-semibold keep-ltr transition-opacity ${live ? "bg-gradient-to-r from-[#C9A227]/25 to-transparent text-[#F5E9C2] border border-[rgba(201,162,39,0.35)]" : "opacity-30 line-through text-gray-500 border border-white/5"}`}>
            {fmtPKR(p)}
          </div>
        );
      })}
    </div>
  );
};
